// extracted by mini-css-extract-plugin
export default {"gameover":"GameOver_gameover__Vzxvk","botao":"GameOver_botao__2rTWb"};